
import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/geist-fonts.css';
import './theme/tailwind.css';
import App from './App';
import { installUmamiAnalytics } from './lib/analytics';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

installUmamiAnalytics();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
